import type { InventoryItemRow } from "~/@types/inventoryItemRow";
import type { ReasonSelection } from "~/helpers/mobile/stickyReason";

export interface InventoryCorrectionDraft {
	grade: string;
	reasonEdited?: boolean;
	hardgoodsLocationId?: string | null;
	locationEdited?: boolean;
	hardgoodsQuantity?: number | null;
	kind: "adjust" | "grade" | "readyDate" | "scrap";
	quantity: null | number;
	readyDate: null | string;
	reason: null | ReasonSelection;
	rows: InventoryItemRow[];
	why: string;
}

const isInventoryCorrectionDraft = (value: unknown): value is InventoryCorrectionDraft => {
	if (typeof value !== "object" || value === null) return false;
	const draft = value as Record<string, unknown>;
	return (
		["adjust", "grade", "readyDate", "scrap"].includes(String(draft.kind)) &&
		(draft.reasonEdited === undefined || typeof draft.reasonEdited === "boolean") &&
		(draft.locationEdited === undefined || typeof draft.locationEdited === "boolean") &&
		(draft.hardgoodsLocationId === undefined ||
			draft.hardgoodsLocationId === null ||
			typeof draft.hardgoodsLocationId === "string") &&
		(draft.hardgoodsQuantity === undefined ||
			draft.hardgoodsQuantity === null ||
			typeof draft.hardgoodsQuantity === "number") &&
		typeof draft.grade === "string" &&
		typeof draft.why === "string" &&
		(draft.quantity === null || typeof draft.quantity === "number") &&
		(draft.readyDate === null || typeof draft.readyDate === "string") &&
		(draft.reason === null ||
			(typeof draft.reason === "object" &&
				draft.reason !== null &&
				typeof (draft.reason as Record<string, unknown>).code === "number" &&
				typeof (draft.reason as Record<string, unknown>).text === "string")) &&
		Array.isArray(draft.rows) &&
		draft.rows.every(
			(row) =>
				typeof row === "object" &&
				row !== null &&
				typeof row.id === "string" &&
				typeof row.itemId === "string" &&
				typeof row.locationId === "string" &&
				typeof row.quantity === "number"
		)
	);
};

export default isInventoryCorrectionDraft;
